var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"ead40"}},[_c('Header'),_c('Banner'),_c('NovosTempos'),_c('Educacao'),_c('Indicado'),_c('GradeCurricular'),_c('Certificado'),_c('Metodologia')],1)}
var staticRenderFns = []

export { render, staticRenderFns }